import { Box } from '@mui/material'
import { TooltipText } from 'components/TooltipText/TooltipText'
import theme from 'lib/theme'
import { Product } from 'types/model/product'
import { formatPrice } from 'lib/utils'
import { RefundCellWrapper, RefundTextStyling } from './OrderProduct.styled'
import { useRefundInfo } from './utils'

export const RefundsColumn = ({ product }: { product: Product }) => {
  const getRefundInfo = useRefundInfo()
  return (
    <Box
      p={1}
      sx={{
        minHeight: theme.spacing(9),
      }}>
      {product.refunds &&
        product.refunds.map((refund) => {
          const { backgroundColor, tooltip } = getRefundInfo(refund.status)
          return (
            <TooltipText key={refund.id} text={tooltip}>
              <RefundCellWrapper getBackgroundColor={backgroundColor}>
                <RefundTextStyling data-testid='refundPill'>
                  {formatPrice(refund.amountVat)}
                  {refund.quantity && refund.quantity > 0
                    ? ` (${refund.quantity})`
                    : null}
                </RefundTextStyling>
              </RefundCellWrapper>
            </TooltipText>
          )
        })}
    </Box>
  )
}
